import React from "react";
import { useCurrentFrame, useVideoConfig } from "remotion";

interface FloatingShapeProps {
  x: number;
  yStart: number;
  size: number;
  color: string;
  type: "circle" | "square" | "triangle" | "star";
  speed: number;
  rotationSpeed: number;
}

const SHAPES: FloatingShapeProps[] = [
  { x: 150, yStart: 200, size: 80, color: "#FF6B00", type: "circle", speed: 1.5, rotationSpeed: 0.4 },
  { x: 850, yStart: 400, size: 90, color: "#A855F7", type: "square", speed: 1.2, rotationSpeed: -0.3 },
  { x: 750, yStart: 1200, size: 100, color: "#06B6D4", type: "circle", speed: 1.8, rotationSpeed: 0.5 },
  { x: 200, yStart: 1400, size: 75, color: "#EC4899", type: "square", speed: 1.4, rotationSpeed: -0.6 },
  { x: 500, yStart: 800, size: 110, color: "#22C55E", type: "circle", speed: 1.1, rotationSpeed: 0.2 },
];

export const NeobrutalistBackground: React.FC = () => {
  const frame = useCurrentFrame();
  const { height } = useVideoConfig();

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "#FFE600",
        backgroundImage: `
          linear-gradient(rgba(0, 0, 0, 0.12) 2px, transparent 2px),
          linear-gradient(90deg, rgba(0, 0, 0, 0.12) 2px, transparent 2px)
        `,
        backgroundSize: "60px 60px",
        overflow: "hidden",
        zIndex: 1,
      }}
    >
      {/* Dynamic drifting brutalist shapes */}
      {SHAPES.map((shape, i) => {
        // Calculate vertical drift with wrapping
        const currentY = (shape.yStart + frame * shape.speed) % (height + 200) - 100;
        const currentRotation = frame * shape.rotationSpeed;

        return (
          <div
            key={i}
            style={{
              position: "absolute",
              left: shape.x,
              top: currentY,
              width: shape.size,
              height: shape.size,
              backgroundColor: shape.color,
              border: "4px solid #000000",
              borderRadius: shape.type === "circle" ? "50%" : "0px",
              boxShadow: "6px 6px 0px #000000",
              transform: `rotate(${currentRotation}deg)`,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              opacity: 0.85,
            }}
          />
        );
      })}

      {/* Retro half-tone dots pattern overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: "radial-gradient(rgba(0,0,0,0.1) 15%, transparent 15%)",
          backgroundSize: "12px 12px",
          pointerEvents: "none",
          zIndex: 2,
        }}
      />
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
